<template>
  <section>
    <!--    订单信息-->
    <Order ref="order"/>
    <!--    调度信息-->
    <dispatch ref="dispatch"/>
    <!--    费用报销-->
    <feeReimbursement ref="feeReimbursement"/>
    <!--    车辆维修-->
    <vehicleRepair ref="vehicleRepair"/>
  </section>


</template>

<script>
import { dZOrderDetail,
} from 'api/operate';
import Order from './order';
import Dispatch from './dispatch';
import FeeReimbursement from './feeReimbursement';
import VehicleRepair from './vehicleRepair';
export default {
  components: {
    Order,
    Dispatch,
    FeeReimbursement,
    VehicleRepair,
  },
  props: {
    orderId: {
      type: String,
    },
  },
  data () {
    return {
    };
  },
  methods: {
    async getData () {
      // 获取 费用报销 列表数据
      // this.$nextTick(() => {
      //   this.$refs.feeReimbursement.saveSearchBoxData({sourceOfGoodsId: this.$route.query.id});
      // });
      // // 获取 车辆维修 列表数据
      // this.$nextTick(() => {
      //   this.$refs.vehicleRepair.saveSearchBoxData({sourceOfGoodsId: this.$route.query.id});
      // });

      const orderId = this.orderId || this.$route.query.orderId;
      const detailRes = await dZOrderDetail({
        orderId,
      });
      if (detailRes.failed) {
        const confirmRes = await this.$confirm('很抱歉，正在维修保养中，请稍后再试！', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: 'warning',
        }).catch(() => { // 取消删除
        });
        if (confirmRes) {
          this.close();
        }
      }
      if (!detailRes.failed) {
        this.$nextTick(() => {
          this.$refs.order.getData(detailRes);
          this.$refs.dispatch.getData(detailRes);
        });
      }
    },
  },
  created () {
    this.getData();
  },
};
</script>

<style scoped>

</style>
